export const ZAPIER_APPS_URL = "https://zapier.com/apps/greip/integrations";
export const ZAPIER_CLIENT_ID = "aiAw3jMmWIKi7ZZnkORGa8MtzekaURxRTcSWfCN5";

export const ALL_INTEGRATION_CATEGORY = "All";

export const integrationCategoryIds = [
  "Automation Tools",
  "Communication & Messaging",
  "E-commerce Platforms",
  "Forms & Surveys",
  "Marketing & CRM",
  "Payments & Billing",
] as const;

export type IntegrationCategory = (typeof integrationCategoryIds)[number];

export type IntegrationCatalogItem = {
  id: string;
  name: string;
  logo: string;
  href: string | null;
  target: "_blank" | null;
  category: IntegrationCategory;
};

export const integrationCatalog = [
  {
    id: "zapier",
    name: "Zapier",
    logo: "zapier.png",
    href: "/integrations/zapier",
    target: null,
    category: "Automation Tools",
  },
  {
    id: "ifttt",
    name: "IFTTT",
    logo: "ifttt.png",
    href: "https://ifttt.com/greip",
    target: "_blank",
    category: "Automation Tools",
  },
  {
    id: "viasocket",
    name: "viaSocket",
    logo: "viasocket.png",
    href: "https://viasocket.com/integrations/greip?utm_source=greip&utm_medium=marketplace&utm_campaign=greip_listing",
    target: "_blank",
    category: "Automation Tools",
  },
  {
    id: "slack",
    name: "Slack",
    logo: "slack.png",
    href: "https://slack.com/oauth/v2/authorize?client_id=5805794541299.5808339862372&scope=channels:join,channels:read,chat:write,chat:write.public,commands&user_scope=&redirect_uri=https://dashboard.greip.io/settings?callback=slack-integration",
    target: "_blank",
    category: "Communication & Messaging",
  },
  {
    id: "make",
    name: "Make.com",
    logo: "make.png",
    href: "https://www.make.com/en/integrations/greip",
    target: "_blank",
    category: "Automation Tools",
  },
  {
    id: "telegram",
    name: "Telegram",
    logo: "telegram.png",
    href: "https://dashboard.greip.io/settings",
    target: null,
    category: "Communication & Messaging",
  },
  {
    id: "mobile-message",
    name: "Mobile Message",
    logo: "mobile-message.png",
    href: "https://mobilemessage.com.au/integrations/app/greip",
    target: "_blank",
    category: "Communication & Messaging",
  },
  {
    id: "zid",
    name: "Zid Platform",
    logo: "zid.png",
    href: null,
    target: null,
    category: "E-commerce Platforms",
  },
  {
    id: "opencart",
    name: "OpenCart",
    logo: "opencart.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "bigcommerce",
    name: "BigCommerce",
    logo: "bigcommerce.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "mailchimp",
    name: "Mailchimp",
    logo: "mailchimp.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Marketing & CRM",
  },
  {
    id: "hubspot",
    name: "HubSpot",
    logo: "hubspot.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Marketing & CRM",
  },
  {
    id: "salesforce",
    name: "Salesforce",
    logo: "salesforce.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Marketing & CRM",
  },
  {
    id: "gravity-forms",
    name: "Gravity Forms",
    logo: "gravityforms.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Forms & Surveys",
  },
  {
    id: "jotform",
    name: "Jotform",
    logo: "jotforms.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Forms & Surveys",
  },
  {
    id: "surveymonkey",
    name: "SurveyMonkey",
    logo: "surveymonkey.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Marketing & CRM",
  },
  {
    id: "paypal",
    name: "PayPal",
    logo: "paypal.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Payments & Billing",
  },
  {
    id: "stripe",
    name: "Stripe",
    logo: "stripe.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Payments & Billing",
  },
  {
    id: "twilio",
    name: "Twilio",
    logo: "twilio.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Communication & Messaging",
  },
  {
    id: "leadpages",
    name: "Leadpages",
    logo: "leadpages.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Marketing & CRM",
  },
  {
    id: "chargify",
    name: "Chargify",
    logo: "chargify.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "volusion",
    name: "Volusion",
    logo: "volusion.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "unbounce",
    name: "Unbounce",
    logo: "unbounce.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Marketing & CRM",
  },
  {
    id: "revolut",
    name: "Revolut",
    logo: "revolut.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Payments & Billing",
  },
  {
    id: "getresponse",
    name: "GetResponse",
    logo: "getresponse.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Marketing & CRM",
  },
  {
    id: "square",
    name: "Square",
    logo: "square.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "dashu",
    name: "DashU",
    logo: "dashu.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "salla",
    name: "Salla",
    logo: "salla.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "shopify",
    name: "Shopify",
    logo: "shopify.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "typeform",
    name: "Typeform",
    logo: "typeform.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Forms & Surveys",
  },
  {
    id: "gift-up",
    name: "Gift Up",
    logo: "giftup.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "magento",
    name: "Magento",
    logo: "magento.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "sendowl",
    name: "SendOwl",
    logo: "sendowl.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "webflow",
    name: "Webflow",
    logo: "webflow.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "woocommerce",
    name: "WooCommerce",
    logo: "woocommerce.jpeg",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "mercury",
    name: "Mercury",
    logo: "mercury.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Payments & Billing",
  },
  {
    id: "apollo",
    name: "Apollo",
    logo: "apollo.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Marketing & CRM",
  },
  {
    id: "intercom",
    name: "Intercom",
    logo: "intercom.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Communication & Messaging",
  },
  {
    id: "happyfox",
    name: "HappyFox",
    logo: "happyfox.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Communication & Messaging",
  },
  {
    id: "neetodesk",
    name: "NeetoDesk",
    logo: "neetodesk.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Communication & Messaging",
  },
  {
    id: "neetoform",
    name: "NeetoForm",
    logo: "neetoform.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Forms & Surveys",
  },
  {
    id: "chargebee",
    name: "Chargebee",
    logo: "chargebee.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "clickfunnels",
    name: "ClickFunnels",
    logo: "clickfunnels.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "Marketing & CRM",
  },
  {
    id: "braintree",
    name: "Braintree",
    logo: "braintree.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "ebay",
    name: "eBay",
    logo: "ebay.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "samcart",
    name: "SamCart",
    logo: "samcart.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "amazon-seller-central",
    name: "Amazon Seller Central",
    logo: "amazonsellercentral.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "lemon-squeezy",
    name: "Lemon Squeezy",
    logo: "lemonsqueezy.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
  {
    id: "surecart",
    name: "SureCart",
    logo: "surecart.png",
    href: ZAPIER_APPS_URL,
    target: "_blank",
    category: "E-commerce Platforms",
  },
] as const satisfies readonly IntegrationCatalogItem[];

export type IntegrationId = (typeof integrationCatalog)[number]["id"];
